export const CMSURL = 'https://citymagento.citypharmacy.ca';
